import { PAGEBUILDER_SET_SUBPAGETYPE } from '../configReducer/actions';

const subPageTypeReducer = (
  state: string = '',
  action: {
    payload: string;
    type: string;
  }
) => {
  switch (action.type) {
    case PAGEBUILDER_SET_SUBPAGETYPE:
      return action.payload;
    default:
      return state;
  }
};

export { subPageTypeReducer };
